/**
 * Noop polyfills for when Drupal content is displayed in iframes on modernized
 * pages.
 */

// Mocking analytics functions when not defined.
(function (w) {
  w.site = w.site || {};
  w.site.track = w.site.track || {};
  w.site.track.evtView = w.site.track.evtView || (() => {});
  w.site.track.evtLink = w.site.track.evtLink || (() => {});
})(window);
